import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { formatApiError } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function RegisterPage({ onSwitchToLogin }) {
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    try {
      await register(email, password, name);
    } catch (err) {
      if (err.response?.data?.detail) {
        setError(formatApiError(err.response.data.detail));
      } else if (err.message) {
        setError(err.message === 'Network Error' ? 'Network error. Check your connection.' : err.message);
      } else {
        setError('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" data-testid="register-page">
      <div className="w-full max-w-sm animate-fade-in">
        <div className="mb-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground mb-2">TU Ilmenau</p>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tighter leading-none font-['Outfit']">
            Create Account
          </h1>
          <p className="text-sm text-muted-foreground mt-3">Set up your timetable viewer</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="bg-destructive/10 text-destructive text-sm p-3 rounded-sm border border-destructive/20" data-testid="register-error">
              {error}
            </div>
          )}
          <div className="space-y-2">
            <Label htmlFor="reg-name" className="text-xs font-bold uppercase tracking-[0.15em]">Name</Label>
            <Input id="reg-name" data-testid="register-name-input" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" required className="rounded-sm h-11 border bg-background" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="reg-email" className="text-xs font-bold uppercase tracking-[0.15em]">Email</Label>
            <Input id="reg-email" data-testid="register-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" required className="rounded-sm h-11 border bg-background" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="reg-password" className="text-xs font-bold uppercase tracking-[0.15em]">Password</Label>
            <Input id="reg-password" data-testid="register-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 6 characters" required className="rounded-sm h-11 border bg-background" />
          </div>
          <Button type="submit" data-testid="register-submit-button" disabled={loading} className="w-full h-11 rounded-sm font-semibold text-sm tracking-wide">
            {loading ? 'Creating account...' : 'Create Account'}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground mt-6 text-center">
          Already have an account?{' '}
          <button onClick={onSwitchToLogin} data-testid="switch-to-login" className="text-primary font-semibold hover:underline underline-offset-4 transition-colors duration-150">
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
}
